import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userData: {},
};

export const userSlice = createSlice({
  name: "user",
  initialState,

  reducers: {
    setUser: (state, action) => {
      state.userData = action.payload;
    },
    logoutUser: (state, action) => {
      state.userData = {};
    },
  },
});

export const selectUser = (state) => state.user.userData;

export const { setUser, logoutUser } = userSlice.actions;

export default userSlice.reducer;
